export default __webpack_public_path__ + "static/cart-6d048c42794f70219ac678524c4b86e9.gif";